export default {
  accueil: {
    derniereConnexion: 'last connection',
    premiereConnexion: 'This is your first login',
    bilanEnCours: 'My ongoing health check-up',
    visite1: 'Fasting exam',
    visite2: 'Consultation',
    visite3: 'Gynecology',
    mammo: 'Mammography',
    dateMammo: 'Set mammo date',
    dateDerniereMammo: 'Last mammography date',
    dureePrevisionnelle: 'Estimated end at',
    osteo: 'Bone densitometry',
    typeVisite: 'Type of visit',
    dateEtEtatVisite: 'Date and state of the visit',
    pasDeBilan: 'There is no ongoing health check-up',
    mesNouveauxDocuments: 'My latest documents',
    plusDocuments: 'More documents',
    activationDMC: {
      activeDmc:
        "You haven't enabled the publication of your medical record information on Extraciem. <br>You can change your choice and authorize the provision of documents using the button below.",
      activeDmcBtn: 'Activate my medical record',
      error:
        'A technical error occurred during the activation of the online medical file.',
    },
    documentsCiem: {
      titre: 'List of CIEM documents',
      headers: {
        documentName: 'Document',
        download: 'Download',
      },
    },
    documents: {
      headers: {
        typeDocument: 'Document type',
        dateCreation: 'Creation date',
        libelleDocument: 'Name',
        download: 'Download',
        annexes: 'Annexes',
      },
    },
    correspondant: {
      administration: {
        titre: 'Administration',
        etablissementRattachement: 'Your company',
        aucunEtablissementRattachement: 'You are not attached to any company',
        entrepriseInseeRattachement: 'Your registered office',
        groupementRattachement: 'Your group',
        aucuneEntrepriseInseeRattachement: 'You are not attached to any seat',
      },
      mutationsEnCours: {
        titre: 'Ongoing mutations',
        entrantes: 'Incoming mutations',
        nombreEntrantes: 'There is {0} Incoming mutation(s)',
        sortantes: 'Outgoing Mutations',
        nombreSortantes: 'There is {0} outgoing mutation(s)',
        nombreMutation: 'There is {0} ongoing mutation(s)',
      },
    },
  },
  error: {
    detail: 'An error occurred while retrieving home information',
  },
}
